// custom.js
document.addEventListener('DOMContentLoaded', () => {
  const checkboxLabel = document.querySelector("label[for='Terms-Conditions']");
  const termsCheckbox = document.getElementById("Terms-Conditions");
  if (!checkboxLabel || !termsCheckbox) return;

  // Funkcja podświetlenia
  const highlight = () => {
    checkboxLabel.classList.add('highlight-red');
  };

  // Nasłuchujemy kliknięcia w całym dokumencie
  document.addEventListener('mousedown', (e) => {
    const checkoutButton = document.querySelector(".cart__checkout, button[name='checkout'], input[name='checkout']");
    if (!checkoutButton) return;

    const rect = checkoutButton.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;

    // Sprawdzamy, czy kliknięcie było "na przycisku"
    if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
      if (!termsCheckbox.checked) {
        e.preventDefault(); // blokujemy checkout jeśli checkbox nie jest zaznaczony
        highlight();        // trwałe podświetlenie
      }
    }
  });

  // Reset po zaznaczeniu checkboxa
  termsCheckbox.addEventListener('change', () => {
    if (termsCheckbox.checked) {
      checkboxLabel.classList.remove('highlight-red');
    }
  });
});